export default class UsecarPointsPlansController {
  constructor(resource) {
    this._resource = resource;
  }

  get() {
    let response = this._resource('usecar-points-plans')
      .get()
      .then(
        v => v,
        err => err
      );
    return response;
  }

  send(data) {
    let response = this._resource('usecar-points-plans')
      .save(data)
      .then(
        v => v,
        err => err
      );
    return response;
  }
}
